import { type MenuItem } from "@client/types";
import { type MenuItemProps } from "@client/widgets/Menu/Item/component";
import classnames from "classnames";
import * as React from "react";
import Link from "../Link/component";
import { getGrid } from "./lib";

export type MegaItemProps = MenuItemProps & {
  containerStyle?: string;
};

interface ItemProps {
  className?: string;
  item: MenuItem;
  children?: any;

  onExpand?: (id: string) => void;
  onToggleClick?: (id: string) => React.MouseEventHandler;
  isClickable: boolean;
  isExpanded: boolean;
  showTitles: boolean;

  style?: React.CSSProperties;
  subMenuStyle?: React.CSSProperties;
  subMenuItemStyle?: React.CSSProperties;
}

const Item = (props: ItemProps) => (
  <li className={props.className}>
    <Link
      isClickable={props.isClickable}
      isExpanded={props.isExpanded}
      onToggleClick={props.onToggleClick}
      item={props.item}
      style={props.style}
    >
      {props.item.label}
      {props.showTitles && props.item.title ? <span className="menu-sub-title">{props.item.title}</span> : null}
    </Link>
    {props.isClickable && !!props.children && (
      <i
        className={classnames("toggle", {
          "far fa-angle-up": props.isExpanded && !!props.onToggleClick,
          "far fa-angle-down": !props.isExpanded && !!props.onToggleClick
        })}
        onClick={props.onToggleClick ? props.onToggleClick(props.item.id) : undefined}
      />
    )}

    {props.children}
  </li>
);

export default (props: MegaItemProps) => (
  <Item
    className={classnames("mega-menu-item", {
      dropdown: !!props.item.children,
      current: props.item.isCurrent,
      active: props.item.isCurrent,
      expanded: props.getIsExpanded(props.item.id)
    })}
    {...props}
    isExpanded={props.getIsExpanded(props.item.id)}
  >
    {!!props.item.children && !!props.item.children.length && (
      <ul
        className={classnames("dropdown-menu", `menu-${props.item.megaOptions?.align || "left"}`)}
        style={props.subMenuStyle}
      >
        <li className={classnames("mega-menu-content container-fluid", {})}>
          {getGrid(props).rows.map((row, ri) => (
            <div key={ri} className="row">
              {row.columns.map((column, ci) => (
                <div key={ci} className={column.className}>
                  <ul>
                    {column.items.map((sitem) => (
                      <Item
                        key={sitem.id}
                        item={sitem}
                        className={classnames({
                          "mega-menu-title": sitem.isDirectChild,
                          current: sitem.isCurrent,
                          active: sitem.isCurrent
                        })}
                        isClickable={false}
                        isExpanded={false}
                        style={props.subMenuItemStyle}
                        showTitles={props.showTitles}
                      />
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          ))}
        </li>
      </ul>
    )}
  </Item>
);
